import Sidebar from "./components/sidebar/Sidebar"
import Topbar from "./components/topbar/Topbar"
import "./App.css"
import Home from "./pages/home/Home"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import UserList from "./pages/userList/UserList"
import User from "./pages/user/User"
import ProductList from "./pages/productList/ProductList"
import OrderList from "./pages/orderList/OrderList"
import Product from "./pages/product/Product"
import NewProduct from "./pages/newProduct/NewProduct"
import Login from "./pages/login/Login"
import Register from "./pages/register/Register"
import Categories from "./pages/categories/Categories"
import EditCategory from "./pages/category/EditCategory"
import NewCategory from "./pages/new category/NewCategory"
import { Redirect } from "react-router-dom"
import { useSelector } from "react-redux"

function App() {
  const user = useSelector((state) => state.user.currentUser)
  const isAdmin = user?.is_admin

  return (
    <Router>
      <Switch>
        <>
          <Route path='/login'>
            {!isAdmin ? <Login /> : <Redirect to='/'></Redirect>}
          </Route>
          <Route path='/register'>
            {!isAdmin ? <Register /> : <Redirect to='/'></Redirect>}
          </Route>
          {!isAdmin ? (
            <Redirect to='/login'></Redirect>
          ) : (
            <>
              <Topbar />

              <div className='container'>
                <Sidebar />
                <Route exact path='/'>
                  <Home />
                </Route>
                <Route path='/users'>
                  <UserList />
                </Route>
                <Route path='/user/:userId'>
                  <User />
                </Route>
                <Route path='/products'>
                  <ProductList />
                </Route>
                <Route path='/orders'>
                  <OrderList />
                </Route>
                <Route path='/product/:productId'>
                  <Product />
                </Route>
                <Route path='/newproduct'>
                  <NewProduct />
                </Route>
                <Route path='/categories'>
                  <Categories />
                </Route>
                <Route path='/category/:categoryId'>
                  <EditCategory />
                </Route>
                <Route path='/newcategory'>
                  <NewCategory />
                </Route>
              </div>
            </>
          )}
        </>
      </Switch>
    </Router>
  )
}

export default App
